export const DEFAULT_QUERY_GROUP_ID = btoa("QueryGroup:/default");
export const ANONYMOUS_QUERY_GROUP_ID = btoa("QueryGroup:/anonymous");
export const DEFAULT_URL_GROUP_ID = btoa("URLGroup:/default");
